export default __webpack_public_path__ + "static/media/card_dexpro2.3b29490a.png";